import _ from 'lodash'
import gameIframe from '../iframe/iframe'
import { Font } from '@com/i18n'
import { readFile } from '@ps/api/editor/file'
import filePath from '../path'
import { cropFont } from '@ps/api/editor/font'
import { defaultFont } from '@ps/bridge/qc/node/text'

const extension = 'ttf'

const cache: {
  [key: string]: string
} = {}

export function setFont(font: string, text: string): void {
  cache[font] = text
}

export function hasFont(font: string): boolean {
  return !_.isUndefined(cache[font])
}

export function fetchFont(
  font:
    | {
        name: string
        url: string
      }
    | string
    | { name: string; url: string }[],
) {
  return new Promise((resolve, reject) => {
    gameIframe.fontLoader.fetch(
      font,
      (data) => {
        resolve(data)
      },
      (data) => {
        reject(data)
      },
    )
  })
}

export async function getFontList({
  fonts,
  pid,
}: {
  fonts: Font[]
  pid: number
}): Promise<{ name: string; url: string }[]> {
  let res = []
  try {
    const promiseList = fonts
      .filter((item) => item.name !== defaultFont)
      .map((font) => {
        let fontName = `${font.name}.${extension}`
        // 处理自定义字体name
        const fontSplit = font.name.split('|')
        if (fontSplit.length > 1) {
          fontName = `${fontSplit[1]!}.${extension}`
        }
        return readFile({
          pid,
          path: `${filePath.FONT_BASIC_PATH}${fontName}`,
          base64: 1,
        })
      })
    res = await Promise.all(promiseList)

    // 如果存在一个加载失败就使用裁切接口加载字体，一般不会走到这个逻辑，所以就不去重了
    // @ts-ignore
    if (res.some((item) => item && item.code === 1)) {
      const promiseList = fonts
        .map((font) => ({
          font: font.name,
          text: font.text.join('').replace(/\s/g, ''),
        }))
        .filter((font) => {
          // 字符为空或默认字体不需要调用裁切接口
          return font.text !== '' && font.font !== defaultFont
        })
        .map((font) =>
          cropFont({
            ...font,
            pid,
          }),
        )
      res = await Promise.all(promiseList)
      return res.map((item, index) => {
        const fontBase64 = _.get(item, 'data.base64')
        return {
          name: fonts[index].name,
          url: fontBase64,
        }
      })
    }
    return res.map((item, index) => {
      return {
        name: fonts[index].name,
        url: item as string,
      }
    })
  } catch (err) {
    console.error('从素材包加载字体失败', err)
    return []
  }
}
